export default __webpack_public_path__ + "static/media/104498_facebook_icon.be85acc7.svg";